/**
 * @author Sarthak Sharma.
 * @since 04-01-2024.
 * @type {string} Project action types.
 */

export const SET_LOADING = "[PROJECT] SET_LOADING";
export const SET_SELECTED_ROLES = "[PROJECT] SET_SELECTED_ROLES";
export const SET_LOCATION_LIST = "[PROJECT] SET_LOCATION_LIST";

export const SET_FORM_ROLE_TYPE = "[PROJECT] SET_FORM_ROLE_TYPE";
export const SET_AUTO_FILL_DESCRIPTION = "[PROJECT] SET_AUTO_FILL_DESCRIPTION";

export const SET_GENERATED_PROJECT = "[PROJECT] SET_GENERATED_PROJECT";
